import axios from "axios";
import { ITiers } from "../models/thirdParty";
import { API_CENTRE } from "./config";
import { apiCallWithAuth } from "../helper/apiManager";

//Service Intervention
export default class TiersService {
  //Recupération du tiers par son ID
  static async getTiersById(id: number) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/thirdparties/" + id
      );
      return {
        err: false,
        data: data,
      };
    } catch (err) {
      return {
        err: true,
        data: err,
      };
    }
  }

  //Récupération des tiers en fonction du filtre
  static async getTiers(
    page: number,
    pageSize: number,
    typeTiers: string = "",
    search: string = "",
  ) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE +
          "/api/v1/thirdparties/search?Include=*&PageNumber=" +
          page +
          "&PageSize=" +
          pageSize +
          "&ThirdPartyTypeCode=" +
          typeTiers +
          "&GlobalSearch=" +
          search +
          "",
      );
      return {
        err: false,
        data: data,
      };
    } catch (err: any) {
      return {
        err: true,
        data: [],
      };
    }
  }

  //Creation d'un tiers
  static async createTiers(tiers: ITiers) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/thirdparties",
        "post",
        tiers,
      );
      return {
        err: false,
        data: data,
      };
    } catch (err: any) {
      return {
        err: true,
        data: err,
      };
    }
  }

  //Mise à jour d'un tiers
  static async updateTiers(tiers: ITiers) {
    try {
      let tiersData = JSON.parse(JSON.stringify(tiers));
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/thirdparties?idTiers=" + tiers.id,
        "put",
        tiersData,
      );
      return {
        err: false,
        data: data,
      };
    } catch (err) {
      return {
        err: true,
        data: err,
      };
    }
  }
}
